module.exports = __webpack_public_path__ + "84770707b16edc2a579c49bd725d8b74.png";